import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import {
  AttendanceActionsTypes,
  dispatchAttendance,
  FormControl,
} from "contexts/attendance-context/actions-reducer";
import { INITIAL_ATTENDANCE_VALUES } from "./utils";
import { useApplicationContext } from "contexts/ApplicationContext";
import { User } from "contexts/types/application-context-types";

interface FormControlContext {
  formControl: FormControl;
  dispatch: React.Dispatch<AttendanceActionsTypes>;
  setConsultandoFGTS: React.Dispatch<React.SetStateAction<boolean>>;
  consultandoFGTS: boolean;
  setReConsultandoFGTS: React.Dispatch<React.SetStateAction<boolean>>;
  reConsultandoFGTS: boolean;
  setTransparentLoading: React.Dispatch<React.SetStateAction<boolean>>;
  transparentLoading: boolean;
  isReadOnly: boolean;
}

const attendanceContext = createContext<FormControlContext>({
  formControl: INITIAL_ATTENDANCE_VALUES,
  dispatch: () => undefined,
  setConsultandoFGTS: () => undefined,
  consultandoFGTS: false,
  setReConsultandoFGTS: () => undefined,
  reConsultandoFGTS: false,
  setTransparentLoading: () => undefined,
  transparentLoading: false,
  isReadOnly: false,
});

export const AttendanceProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [formControl, dispatch] = useReducer(
    dispatchAttendance,
    INITIAL_ATTENDANCE_VALUES
  );
  const [consultandoFGTS, setConsultandoFGTS] = useState(false);
  const [reConsultandoFGTS, setReConsultandoFGTS] = useState(false);
  const [transparentLoading, setTransparentLoading] = useState(false);
  const { user } = useApplicationContext();
  const attendanceUser = formControl.values.user;
  const attendanceUserId = attendanceUser?.id;
  const loggedUserId = user.userData.userId;
  let isReadOnly = false;

  if (user.userData.type === "PARCEIRO_VENDEDOR") {
    isReadOnly = loggedUserId !== attendanceUserId;
  } else if (
    ["PARCEIRO_MASTER", "COMERCIAL", "REGIONAL", "SUPER"].includes(
      user.userData.type!
    )
  ) {
    isReadOnly = loggedUserId !== attendanceUserId && !!attendanceUser?.vendeai;
  }

  return (
    <attendanceContext.Provider
      value={{
        dispatch,
        formControl,
        setConsultandoFGTS,
        consultandoFGTS,
        setReConsultandoFGTS,
        reConsultandoFGTS,
        setTransparentLoading,
        transparentLoading,
        isReadOnly,
      }}
    >
      {children}
    </attendanceContext.Provider>
  );
};

export const useAttendanceContext = () => {
  const context = useContext(attendanceContext);
  if (context === undefined)
    throw new Error(
      "useApplicationContext must be used within a ApplicationContextProvider"
    );
  return context;
};
